// Staff workload rows on the firm dashboard - real per-member counts from
// GET /api/firm/assignments. The route is admin-gated, so other roles
// get an honest note instead of an invented capacity percent.

import { useNavigate } from "react-router-dom";
import { useFirmWorkload } from "../../hooks/useFirmWorkload";
import { colorFor, heatColor } from "../../lib/staffVisuals";
import { initialsOf } from "../../api/auth";
import { EntityLink } from "../chrome/EntityLink";
import { Skeleton } from "../chrome/Skeleton";
import { ARROW, SEP } from "../chrome/SepList";

export function StaffWorkload() {
  const navigate = useNavigate();
  const q = useFirmWorkload();
  const workload = q.data?.allowed ? q.data.workload : null;

  return (
    <div className="cc-card">
      <div className="cc-card-head">
        <div className="cc-card-title">Staff workload</div>
        <div className="cc-card-sub">{SEP}active matters</div>
        <div className="actions">
          <button
            type="button"
            className="cc-link-btn"
            onClick={() => navigate("/team")}
            title="Manage team assignments"
          >
            Reassign {ARROW}
          </button>
        </div>
      </div>
      <div className="cc-staff">
        {q.isLoading && (
          <div style={{ padding: "10px 18px" }}>
            <Skeleton width="100%" height={40} radius={8} />
          </div>
        )}
        {q.isError && (
          <div style={{ padding: "10px 18px", fontSize: 12, color: "var(--warn-600)" }}>
            Could not reach the server - workload is unavailable.
          </div>
        )}
        {q.data && !q.data.allowed && (
          <div style={{ padding: "10px 18px", fontSize: 12, color: "var(--muted)" }}>
            Workload numbers require an admin sign-in.
          </div>
        )}
        {workload && workload.length === 0 && (
          <div style={{ padding: "10px 18px", fontSize: 12, color: "var(--muted)" }}>
            No staff accounts yet.
          </div>
        )}
        {workload?.map((w) => (
          <div key={w.user.id} className="cc-staff-row">
            <EntityLink
              kind="team"
              id={w.user.id}
              subtle
              ariaLabel={`Open ${w.user.fullName} profile`}
              className="av"
              style={{ background: colorFor(w.user.id) }}
            >
              {initialsOf(w.user.fullName)}
            </EntityLink>
            <div>
              <div className="who">
                <EntityLink kind="team" id={w.user.id} subtle>
                  {w.user.fullName}
                </EntityLink>
              </div>
              <div className="role">
                {w.user.role}
                {SEP}
                {w.activeCount} active
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 11 }}>
              {w.overdueCount > 0 && (
                <span style={{ color: "var(--red-700)" }}>
                  {w.overdueCount} overdue {w.overdueCount === 1 ? "deadline" : "deadlines"}
                </span>
              )}
              <span style={{ color: heatColor(w.workloadHeat) }}>{w.workloadHeat}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
